import { Component, Input } from '@angular/core';
import { NgMapsCoreModule } from '@ng-maps/core';
import { NgMapsGoogleModule } from '@ng-maps/google';
import { TranslatePipe } from '@ngx-translate/core';
import { SiteDto } from '@dto';
import { detectBrowser } from '@helpers';

@Component({
  imports: [TranslatePipe, NgMapsGoogleModule, NgMapsCoreModule],

  selector: 'monitor-ui-site-home',
  styleUrls: ['./site-home.component.scss'],
  templateUrl: './site-home.component.html',
})
export class SiteHomeComponent {
  isFirefox: boolean;
  @Input() site: SiteDto;

  constructor() {
    this.isFirefox = detectBrowser().includes('Firefox');
  }
}
